/**
 * ComplianceVault shape normaliser (client / ES module).
 *
 * ComplianceVault docs store the same bank/compliance fields in two live shapes:
 *   - FLAT root (canonical / current):  vault.accountNumber, vault.idNumber, ...
 *   - nested `bankDetails` (legacy):     vault.bankDetails.accountNumber, ...
 *
 * flattenVault merges both into ONE flat object (nested `bankDetails` wins on
 * conflict), so every consumer can read `flat.accountNumber` / `flat.idNumber`
 * etc. without caring which shape the doc uses. Mirrors
 * functions/utils/vaultNormalizer.js.
 *
 * @param {Object|null|undefined} vault - raw ComplianceVault document data
 * @returns {Object} flattened, shape-agnostic field map
 */
export function flattenVault(vault) {
  const v = vault || {};
  const flat = { ...v, ...(v.bankDetails || {}) };
  // Some docs carry the ID number on the idDocument metadata object
  // (ComplianceVault.{uid}.idDocument.idNumber). Use it as a lowest-precedence
  // fallback only — root / bankDetails win when they hold a non-empty value.
  // (Deliberately NOT spreading idDocument: its status/uploadDate keys would
  // pollute the flat view.)
  if (!flat.idNumber && v.idDocument && v.idDocument.idNumber) {
    flat.idNumber = v.idDocument.idNumber;
  }
  return flat;
}
